<template>
    <div class="user-join text-center note">        
        {{$t("User")}} <b class="link" @click="ShowUser(message_doc.user_id)">{{GetUser(message_doc.user_id).username}}</b> {{$t("has left the channel at ")}} 
        <b>{{new Date(message_doc.created_at * 1000).toLocaleDateString($i18n.locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric' })}}</b>
    </div>
</template>




<script>
import Vue from 'vue'
import Global from '../scripts/Global'
import { Post } from '../classes/Post'
import { CPUtils } from '../scripts/Utils'
import MessageBuilder from '../Builder/Message.builder'
import FileApi from '../scripts/api/file.api'
import { serverBus } from '../main'
import SessionManager from '../Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals'
import CPLink from './CPLink'



export default {
  name: 'LeaveMessage',
  data: function() {
    return {
      postHoverID: ''
    }
  },  
  props: {
    message_doc: Object,
  },
  mounted() {  

  },
  methods : {
      GetUser(user_id){      
          let user = SessionManager.getUser(user_id)
          if(typeof user != 'undefined')
            return user

      return '' 
    },
    ShowUser(user_id){
        Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
        Global.globalValue(VueSignals.SHOW_MENTION_DETAILS, {
            "data_id": user_id,
            "type": 'user'
        })
    }
  }
}
</script>